import {
  ActionIcon,
  Button,
  Group,
  Modal,
  Text,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCircleCheck, IconTrash } from "@tabler/icons-react";
import React, { useReducer } from "react";
import { notifications } from "@mantine/notifications";
import { url } from "../../settings/linkUrl";

interface dataremove {
  id: string;
  path: string;
  onLoadPage: () => any;
}

export default function RemoveRegsiter({ id, path, onLoadPage }: dataremove) {
  const [opened, { open, close }] = useDisclosure(false);
  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const funcSubmit = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(`${url}${path}/${id}`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.success === "1") {
          notifications.show({
            title: "แจ้งเตือน",
            message: "ลบข้อมูลสำเร็จ",
            autoClose: 3000,
            icon: <IconCircleCheck />,
            color: "red",
          });
        }
        close();
        onLoadPage();
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        size="sm"
        centered
        title="ยืนยันการลบข้อมูล"
        transitionProps={{
          transition: "fade",
          duration: 220,
          timingFunction: "ease",
        }}
      >
        <Text fz="sm" c="dimmed">
          ท่านต้องการลบข้อมูลรหัส <Text span fw={600} c="dark">{id}</Text> หรือไม่?
          การลบไม่สามารถย้อนกลับได้
        </Text>

        <Group justify="flex-end" mt="lg" gap="sm">
          <Button variant="default" onClick={close}>
            ยกเลิก
          </Button>
          <Button color="red" loading={!!data.loading} onClick={funcSubmit}>
            ยืนยันลบ
          </Button>
        </Group>
      </Modal>
      <Tooltip label="ลบข้อมูลการลงทะเบียน" withArrow>
        <ActionIcon
          radius="md"
          color="red"
          variant="light"
          onClick={open}
          aria-label="ลบข้อมูล"
        >
          <IconTrash size="1.05rem" />
        </ActionIcon>
      </Tooltip>
    </>
  );
}
